module.exports = "/static/assets/76aab724a3dee349e125c5293ff55c0f.png";